<div class="discipline-circle" [ngClass]="[statusClass, isDisabled ? 'disabled' : '']" [title]="disciplineNumber">
  {{ disciplineNumber }}
</div>
